const styles = {
  headerContainer: {
    height: '56px',
    display: 'flex',
    padding: '0px 24px',
    width: '100%',
    alignItems: 'center',
    borderBottom: '1px solid #E0E0E0',
    justifyContent: 'space-between',
  },
  previewSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    width: '100%',
  },
  deviceSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    justifyContent: 'center',
    width: '100%',
  },
  closeSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  previewText: {
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'Inter',
  },
  closeText: {
    fontSize: '14px',
    fontWeight: 500,
  },
  eyeIcon: {
    fontSize: '20px',
  },
}

export default styles
